import { DialogActions } from '@material-ui/core';
import { COLORS, FONT_COLORS } from 'constants/design';
import styled from 'styled-components';

export const DecisionWrapper = styled.div`
  position: absolute;
  right: 0;
  margin-top: -60px;
`;

export const StyleTitleDialog = {
  color: FONT_COLORS.BLACK,
  fontSize: '32px',
  lineHeight: '40px',
  marginBottom: '20px',
};
export const StyleDescriptionDialog = {
  fontSize: '14px',
  lineHeight: '20px',
  color: FONT_COLORS.DARK_BLACK_GREY,
};

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  padding: 20px 30px;

  .moveButton {
    border: 1px solid ${COLORS.PRIMARY_BUTTON_BLUE};
    background-color: ${COLORS.PRIMARY_BUTTON_BLUE};
    color: ${COLORS.WHITE};
    &:hover {
      background-color: ${COLORS.PRIMARY_BUTTON_BLUE};
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;
